export default "__VITE_ASSET__CgVHPcIA__"